var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('nav',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("逻辑公式化简与真值表")]),_vm._v(" | "),_c('router-link',{attrs:{"to":"/about"}},[_vm._v("使用说明")])],1),_c('keep-alive',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }